// extracted by mini-css-extract-plugin
module.exports = {"disabled":"_3Av0ZtAVNi9Et6vO6Rsm-v","dataValuePair":"_3mwJoclpGV-bl98YrhOOvm","dataValuePairLabel":"_5Jfly9iR3hRnonCTDqyd8","dataValuePairValue":"_2Q7HjgPgKdq3LLK1AGFsPP"};